// jQuery('summary.menu-drawer__menu-item').click(function(){
//     console.log('opensubmenu');
//     jQuery('.menu-drawer').addClass('top-aligned');
//     jQuery('.announcement-bar-section').addClass('top-aligned');
// });
//
// jQuery('.menu-drawer__close-button').click(function(){
//     console.log('closesubmenu');
//     jQuery('.menu-drawer').removeClass('top-aligned');
//     jQuery('.announcement-bar-section').removeClass('top-aligned');
// });

// Function to handle menu actions
function handleMenu() {
    // Check if the screen width is less than or equal to 767px
    if (window.innerWidth <= 767) {
        // Open submenu
        jQuery('summary.menu-drawer__menu-item').click(function(){
            console.log('opensubmenu');
            jQuery('.menu-drawer').addClass('top-aligned');
            jQuery('.announcement-bar-section').addClass('top-aligned');
        });

        // Close submenu
        jQuery('.menu-drawer__close-button').click(function(){
            console.log('closesubmenu');
            jQuery('.menu-drawer').removeClass('top-aligned');
            jQuery('.announcement-bar-section').removeClass('top-aligned');
        });
    } else {
        // Clean up event handlers if the screen width is more than 767px
        jQuery('summary.menu-drawer__menu-item').off('click');
        jQuery('.menu-drawer__close-button').off('click');

        // Remove any added classes if window width is greater than 767px
        jQuery('.menu-drawer').removeClass('top-aligned');
        jQuery('.announcement-bar-section').removeClass('top-aligned');
    }
}

// Run the function initially to check the screen size
handleMenu();

// Run the function whenever the window is resized
jQuery(window).resize(function() {
    handleMenu();
});

//Collection page view toggle
jQuery('body.template-collection').on('click','.toggle-it',function(){
    jQuery('.toggle-it').removeClass('active');
    jQuery(this).addClass('active');
    if (jQuery(this).hasClass('v-list')) {
        jQuery('#ProductGridContainer').addClass('toggled v-list');
        jQuery('.v-toggle').addClass('list-active');
        jQuery('#ProductGridContainer').removeClass('v-grid');
    }else if(jQuery(this).hasClass('v-grid')) {
        jQuery('#ProductGridContainer').addClass('toggled v-grid');
        jQuery('#ProductGridContainer').removeClass('v-list');
    }
});

//Collection filters opening trigger
jQuery('.mobile-facets__open').click(function(){
    jQuery('.mobile-facets__details').attr('open','');
});

jQuery('.mobile-facets__close-button').click(function(){
    if(jQuery(this).hasClass('collapse')){
        jQuery(this).removeClass('collapse');
        jQuery(this).siblings('.mobile-facets__list').removeClass('hide');
    }else{
        jQuery(this).addClass('collapse');
        jQuery(this).siblings('.mobile-facets__list').addClass('hide');
    }
});

/* Price range slider */
/* Price range slider */
jQuery(document).on('input', '.min-range', function() {
    let minVal = jQuery(this).val();
    //console.log(minVal);
    jQuery('input[name="filter.v.price.gte"]').val(minVal);
});

jQuery(document).on('input', '.max-range', function() {
    let maxVal = jQuery(this).val();
    jQuery('input[name="filter.v.price.lte"]').val(maxVal);
    //console.log(maxVal);
});

jQuery('input[name="filter.v.price.gte"]').on("input", function() {
    let mintextVal = jQuery(this).val();
    jQuery('.min-range').val(mintextVal);
    //console.log(mintextVal);
});

jQuery('input[name="filter.v.price.lte"]').on("input", function() {
    let maxtextVal = jQuery(this).val();
    jQuery('.max-range').val(maxtextVal);
    //console.log(maxtextVal);
});

/* Contact agreement */
jQuery('body.template-page-contact #agree-terms').change(function() {
    // Toggle the 'checked' class on the parent label
    jQuery('.agree-terms').toggleClass('checked', this.checked);
});

/* Article page related blogs section hide if no post found */
jQuery(document).ready(function(){

    if(!jQuery('.template-article .rel_articles li').length){
        jQuery('.template-article .rel_articles').hide();
    }

    window.ymmProductHandle = localStorage.getItem('selectedProductHandle');
    window.small_text_for_selected_widget = localStorage.getItem('small_text_for_selected_widget');
    window.title_for_selected_widget = localStorage.getItem('title_for_selected_widget');
    window.featuredImg = localStorage.getItem('featuredImg');
    window.searchExist = localStorage.getItem('searchExist');

    // YMM load dynamic data from form globally on custom widgets
    if(window.title_for_selected_widget){
        jQuery('.select_vehicle .select-v-text,.template-product .widget-prod-title').text(window.title_for_selected_widget);
        jQuery('.template-product .widget-smaller-text').text(window.small_text_for_selected_widget);
        var imghtml = '<img src="'+ window.featuredImg +'">';
        jQuery('.ymm-widget .select_vehicle .svg-wrapper').html(imghtml);
        jQuery('body.template-product .product__info-container .ymm-widget').addClass('selected');
        jQuery('.select_vehicle').addClass('selected');
        jQuery('.select_vehicle .count').text('1');
    }

    if(window.location.pathname.split('/')[2] == window.ymmProductHandle){
        jQuery('.widget-selected-prod').addClass('showwidget');
    }

    //YMM form html change
    jQuery('#ymm_label').html('<strong class="upper">Find the right spare wheel</strong> for your car');

});

// YMM App extension with local storage
// jQuery(document).ready(function (){
//     if (window.location.pathname.includes('/products/')) {
//         var urlParams = new URLSearchParams(window.location.search);
//         var rqParam = urlParams.get('rq');  // Example: "yr_2015~mk_audi~md_a3-s3"
//
//         if (rqParam) {
//             var parameters = rqParam.split('~'); // Split the "rq" value into key-value pairs
//
//             // Loop through each parameter and check if it matches the keys "yr_", "mk_", "md_"
//             parameters.forEach(function (param) {
//                 var keyValue = param.split('_');  // Split by "_" to get key and value
//
//                 if (keyValue[0] === 'yr' || keyValue[0] === 'mk' || keyValue[0] === 'md') {
//                     // If the key matches "yr_", "mk_", or "md_", store it in localStorage
//                     localStorage.setItem('selected' + keyValue[0].toUpperCase(), keyValue[1]);
//                     var productHandle = window.location.pathname.split('/')[2];  // Example: "audi-a3-s3-space-saver-spare-wheel-braumach-spare-wheel-kit-all-models-2013-2025"
//                     // Store the product handle in localStorage
//                     localStorage.setItem('selectedProductHandle', productHandle);
//                     window.ymmProductHandle = localStorage.getItem('selectedProductHandle');
//                 }
//             });
//         }
//     }
//
// });

// Fetch YMM product handle and show it on widgets
// jQuery(document).ready(function(){
//      console.log(ymmProductHandle);
//
//     const handle = ymmProductHandle;  // Example product handle
//
//     const fetchProductDetails = async (handle) => {
//         const response = await fetch(`/products/${handle}.js`);
//         const product = await response.json();
//
//         console.log(product); // This contains all product details
//
//         // Now you need to fetch metafields via Liquid
//         fetchMetafields(handle);
//     };
//
//     const fetchMetafields = (handle) => {
//         // Make a separate AJAX call to fetch metafields (this can be customized server-side)
//         fetch(`/metafields/${handle}.json`)
//             .then(response => response.json())
//             .then(data => {
//                 console.log(data);  // Handle the metafield data
//             });
//     };
//
//     fetchProductDetails(handle);
//
// });

//Multirow section on product page append into another div
jQuery(document).ready(function(){
  var multiLayerHtml = jQuery('.template-product .multirow').parent('.shopify-section').prop('outerHTML');
  jQuery('.template-product .multirow').parent('.shopify-section').hide();
  jQuery('.template-product .multi-layer').append(multiLayerHtml);
});